/* eslint-disable indent */
import { logError } from '@log';
import { request } from './request';
import {
  // MOCK_LOGIN_RESP,
  // MOCK_GET_RA_REASON,
  // MOCK_RA_ITEMS,
  // MOCK_DHGATE_ITEMS,
} from './mock';

const url = 'replenish-fulfillment';

export const fulfilledTracking = async (body) => {
  try {
    if (!Object.keys(body)?.length) {
      logError(new Error('Error request'));
      return null;
    }
    const resp = await request(url, { body });

    if (!resp) {
      logError(new Error(`${url} no resp`));
      return null;
    }
    return resp;
  } catch (error) {
    logError(error);
    return null;
  }
};
